import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-line-graph',
  templateUrl: './dashboard-line-graph.component.html',
  styleUrls: ['./dashboard-line-graph.component.css']
})
export class DashboardLineGraphComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
